const initialActivitiesData = [
  {
    id: 0,
    title: 'Vienna-Baden on bike',
    typeTitle: 'Biking',
    date: 1618746311990,
    distanceKm: 31.710,
    distanceM: 3171.025,
    durationGPS: '02:37:09',
    durationStartStop: '02:43:06',
    steps: '',
    geojson: {
      type: 'FeatureCollection',
      features: [
        {
          type: 'Feature',
          id: 5,
          properties: {
            coordinatesExtended: [
              [
                16.4026648,
                48.18468,
                221.97763476959688,
                1618746311990,
                null,
                null,
                42.5,
                null,
                true,
                { km: '0.000', m: '0.000' },
                '200'
              ],
              [
                16.4039491,
                48.1844052,
                221.68258565885344,
                1618746313172,
                null,
                null,
                57.10599899291992,
                null,
                true,
                { km: '0.000', m: '0.000' },
                '200'
              ],
              [
                16.4038721,
                48.1842651,
                221.7065768090127,
                1618746314360,
                151.76560974121094,
                3.064467668533325,
                4.892000198364258,
                null,
                true,
                {
                  km: '0.100',
                  m: '100.000'
                },
                '200'
              ],
              [
                16.4038828,
                48.1842517,
                221.7492708388076,
                1618746315055,
                151.93467712402344,
                3.1256585121154785,
                5.099999904632568,
                null,
                true,
                {
                  km: '0.120',
                  m: '116.590'
                },
                '200'
              ],
              [
                16.4039229,
                48.1842326,
                221.79346691551717,
                1618746316266,
                150.00535583496094,
                4.516114711761475,
                5.8379998207092285,
                null,
                true,
                {
                  km: '0.120',
                  m: '118.280'
                },
                '200'
              ],
              [
                16.4039366,
                48.1842079,
                221.78558338424554,
                1618746317233,
                147.2406463623047,
                4.697610855102539,
                5.705999851226807,
                null,
                true,
                {
                  km: '0.120',
                  m: '121.930'
                },
                '200'
              ],
              [
                16.4039566,
                48.1841709,
                222.13927834659282,
                1618746318232,
                149.8452606201172,
                4.623770713806152,
                5.388999938964844,
                null,
                true,
                {
                  km: '0.120',
                  m: '124.860'
                },
                '200'
              ],
              [
                16.4039757,
                48.184128,
                222.15850847722464,
                1618746319271,
                150.97926330566406,
                4.601945877075195,
                5.176000118255615,
                null,
                true,
                {
                  km: '0.130',
                  m: '129.230'
                },
                '200'
              ],
              [
                16.4039971,
                48.1840864,
                222.1477459453525,
                1618746320229,
                148.003662109375,
                4.6899495124816895,
                4.988999843597412,
                null,
                true,
                {
                  km: '0.130',
                  m: '134.210'
                },
                '200'
              ],
              [
                16.404026,
                48.1840474,
                222.16893023752255,
                1618746321233,
                144.01185607910156,
                4.650184631347656,
                4.833000183105469,
                null,
                true,
                {
                  km: '0.140',
                  m: '139.100'
                },
                '200'
              ]
            ],
            distanceKm: '31.720',
            distanceM: '3172.025',
            durationInSeconds: 9429,
            endTime: 1618756097755,
            note: 'This application adds extended geoJson data to properties.coordinatesExtended: [lon,lat,altitude,now(),heading,speed,accuracy,altitudeAccuracy,recording].',
            startTime: 1618746311899,
            steps: 0,
            timerDisplay: '02:37:09',
            title: 'Biking',
            typeId: 1,
            typeTitle: 'Biking'
          },
          geometry: {
            type: 'LineString',
            coordinates: [
              [
                16.4026648,
                48.18468,
                221.97763476959688
              ],
              [
                16.4039491,
                48.1844052,
                221.68258565885344
              ],
              [
                16.4038721,
                48.1842651,
                221.7065768090127
              ],
              [
                16.4038828,
                48.1842517,
                221.7492708388076
              ],
              [
                16.4039229,
                48.1842326,
                221.79346691551717
              ],
              [
                16.4039366,
                48.1842079,
                221.78558338424554
              ],
              [
                16.4039566,
                48.1841709,
                222.13927834659282
              ],
              [
                16.4039757,
                48.184128,
                222.15850847722464
              ],
              [
                16.4039971,
                48.1840864,
                222.1477459453525
              ],
              [
                16.404026,
                48.1840474,
                222.16893023752255
              ]
            ]
          }
        }
      ]
    }
  }
]

export default initialActivitiesData
